import { SearchCollection, SearchDTO, SearchMultiDTO } from "@webapp/search/models/search.models";
import { ISearchParams, ISearchRequestsBody } from "@webapp/search/models/search-api.models";
import { IRequestShortcutConfig } from "angular";
import { ICollection } from "@gtmhub/models";
import { EnvironmentService } from "@gtmhub/env";
import { AssigneeType } from "@gtmhub/assignees";
import { buildSearchConditions, searchCollectionsMap, searchFieldsMap } from "@gtmhub/search/utils/global-search";
import { IGlobalMultiSearchItems } from "@gtmhub/search";

export interface ISearchSettings {
  activeUsersOnly?: boolean;
  activeTeamsOnly?: boolean;
}

export const compoundSuffix = "Compound";

export class SearchService {
  public static $inject = ["$http", "EnvironmentService"];

  constructor(private $http: ng.IHttpService, private env: EnvironmentService) {}

  public getSomeSearchData<T>(searchBody: Partial<SearchDTO>, queryParams?: Partial<ISearchParams>): ng.IPromise<ICollection<T>> {
    const url = this.env.getSearchEndpoint(`/multi`);
    const query: IRequestShortcutConfig = {
      params: queryParams,
    };

    return this.$http.post<ICollection<T>>(url, searchBody, query).then((response) => response.data);
  }

  public getSearchDataV2(searchBody: Partial<SearchMultiDTO>, queryParams?: Partial<ISearchParams>): ng.IPromise<IGlobalMultiSearchItems> {
    const url = this.env.getSearchEndpointV2("/multi");
    const query: IRequestShortcutConfig = {
      params: queryParams,
    };

    return this.$http.post<IGlobalMultiSearchItems>(url, searchBody, query).then((response) => response.data);
  }

  public getSearchBody(searchTerm: string, currentFacet: string, settings: ISearchSettings = {}): Partial<SearchDTO> {
    const compound = searchCollectionsMap[currentFacet].length > 1;

    return {
      searchTerm,
      operator: 0,
      searchRequests: searchCollectionsMap[currentFacet].map((collection) => {
        const collectionKey = compound ? collection + compoundSuffix : collection;

        return {
          collectionName: collection,
          searchFields: searchFieldsMap[collectionKey].map((field: string) => {
            return {
              name: field,
            };
          }),
          searchConditions: buildSearchConditions(collection, settings),
        };
      }),
    };
  }

  public getAssigneeSearchCollections(assigneeType: AssigneeType, searchTerm: string, settings?: ISearchSettings): ISearchRequestsBody[] {
    const searchSettings: ISearchSettings = settings || { activeUsersOnly: true, activeTeamsOnly: true };
    const searchCollectionsMap: { [key in SearchCollection]?: ISearchRequestsBody } = {
      teams: {
        collectionName: "teams",
        searchFields: searchTerm ? [{ name: "name" }, { name: "description" }] : [],
        searchConditions: buildSearchConditions("teams", searchSettings),
      },
      users: {
        collectionName: "users",
        searchFields: searchTerm ? [{ name: "fullName" }, { name: "auth0Cache.email" }] : [],
        searchConditions: buildSearchConditions("users", searchSettings),
      },
    };

    if (!assigneeType || assigneeType === "both") {
      return Object.values(searchCollectionsMap);
    }

    if (assigneeType === "user") {
      return [searchCollectionsMap.users];
    }

    if (assigneeType === "team") {
      return [searchCollectionsMap.teams];
    }

    return [];
  }
}
